import { Dic } from "functions/common";
import {
    PARTNER_OPEN_TRIP_ADD,
    GET_SERVICES,
    GUIDE_OPEN_TRIP_LIST,
    DETAIL_GUIDE_TRIP,
    PRIVATE_ADD_MODE,
    EDIT_MODE,
    ADD_MODE,
    GUIDE_PRIVATE_TRIP_LIST,
    SEARCH_TRIPS,
    DETAIL_TRIP,
    OTHERS_DETAIL_TRIP,
    LISTING_TRIP_ID,
    DELETE_SERVICE
} from "./action";
import { FEATURED_HOME_TRIP, PRIVATE_TRIP_AUTHOR, RECENT_OPEN_TRIP } from "./homeAction";

let initialState: {
    addMode: any,
    addOpenTrip: any,
    addPrivateTrip: any,
    loadOn: any,
    services: any,
    guideOpenTripList: any,
    guidePrivateTripList: any,
    detailGuideTrip: any,
    featuredHomeTrip: any,
    privateTripAuthor: any,
    detailTrip: any,
    OthersOnDetailTrip: any,
    searchedTrips: { keyword?: string, data?: any, page?: any, last?: boolean } | null,
    recentOpenTrips: [] | null,
    listingTripId: any,
    deleteService: []
} = {
    addOpenTrip: null,
    addPrivateTrip: null,
    loadOn: null,
    services: [],
    guideOpenTripList: null,
    guidePrivateTripList: null,
    OthersOnDetailTrip: null,
    detailGuideTrip: null,
    featuredHomeTrip: null,
    privateTripAuthor: null,
    addMode: null,
    searchedTrips: null,
    detailTrip: null,
    recentOpenTrips: null,
    listingTripId: 0,
    deleteService: []

};
function listingReducer(state = initialState, action: { type: any; payload: any; }) {
    switch (action.type) {
        case DETAIL_TRIP:
            return { ...state, detailTrip: action.payload };
        case OTHERS_DETAIL_TRIP:
            return { ...state, OthersOnDetailTrip: action.payload };
        case SEARCH_TRIPS:
            let newSearchTrips = state.searchedTrips;
            if (
                newSearchTrips != null &&
                Array.isArray(newSearchTrips.data) &&
                action.payload !== null &&
                Array.isArray(action.payload.data) &&
                (action.payload.page === undefined || parseInt(action.payload.page, 10) > 1)
            ) {
                let currentData = newSearchTrips.data;
                if (action.payload.data.length > 0) {
                    newSearchTrips = {
                        ...newSearchTrips,
                        data: [...currentData, ...action.payload.data],
                        last: action.payload.last ?? false,
                        page: action.payload.page
                    };
                } else {
                    newSearchTrips = { ...newSearchTrips, last: true, page: action.payload.page };
                }
            } else {
                newSearchTrips = action.payload;
            }
            return { ...state, searchedTrips: newSearchTrips };
        case PARTNER_OPEN_TRIP_ADD:
            if (action.payload?.resetForm) {
                state.addMode = null;
            }
            return { ...state, addOpenTrip: action.payload };
        case GET_SERVICES:
            return { ...state, services: action.payload };
        case GUIDE_OPEN_TRIP_LIST:
            return { ...state, guideOpenTripList: action.payload };
        case FEATURED_HOME_TRIP:
            let featuredData: any = state.featuredHomeTrip ?? {};
            featuredData[action.payload.country] = action.payload.data;
            return { ...state, featuredHomeTrip: featuredData };
        case PRIVATE_TRIP_AUTHOR:
            let privateTripAuthor: any = state.privateTripAuthor ?? {};
            privateTripAuthor[action.payload.id] = action.payload.data;
            return { ...state, privateTripAuthor: privateTripAuthor };
        case GUIDE_PRIVATE_TRIP_LIST:
            return { ...state, guidePrivateTripList: action.payload };
        case DETAIL_GUIDE_TRIP:
            return { ...state, detailGuideTrip: action.payload };
        case PRIVATE_ADD_MODE:
            var mode = (action.payload).length > 0 ? EDIT_MODE : ADD_MODE;
            state.addMode = mode;
            return { ...state, detailGuideTrip: action.payload, addOpenTrip: action.payload };
        case ADD_MODE:
            return { ...state, addMode: action.payload };
        case LISTING_TRIP_ID:
            return { ...state, listingTripId: action.payload };
        case RECENT_OPEN_TRIP:
            return { ...state, recentOpenTrips: action.payload };
        case DELETE_SERVICE:
            return { ...state, deleteService: action.payload };
        default:
            return state;
    }
}
export default listingReducer;
